import React, { useEffect, useState, useContext } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button, InputLabel } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { ListItem, Checkbox } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { BASE_URL } from "../../../constants.tsx";
import Tabs from "@material-ui/core/Tabs";
import { useHistory, useLocation } from "react-router";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import HeaderMenu from "../../../Components/HeaderMenu";
import BannerImage from "../../../Images/TealCAFbanner.png";
import Paper from "@material-ui/core/Paper";
import DataService from "../../../Service";
import IconButton from "@material-ui/core/IconButton";
import Select from "@material-ui/core/Select/Select";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import { useParams } from "react-router-dom";
import DataClient from "../../../Service/general_data_service";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import MenuItem from "@material-ui/core/MenuItem";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Fab from "@material-ui/core/Fab";
import Zoom from "@material-ui/core/Zoom";
import { useSelector, useDispatch } from "react-redux";

import useHideOnScrolled from "../../../Components/UseHideOnScrolled";

const useStyles = makeStyles((theme) => ({
  root1: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(10),
  },
  bannerStyle: {
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1301,
    position: "sticky",
  },
  // demo1: {
  //   backgroundColor: theme.palette.background.paper,
  //   // position: "absolute",
  //   // top: "41%",
  //   marginLeft: "11%",
  //   // marginBottom:'25px',
  //   width: "80.6%",
  //   // padding: "5%",
  // },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    width: "80.6%",
    marginTop: "-125px",
    zIndex: 1301,
    position: "fixed",
    // padding: "5%",
  },
  statsBoard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    width: "17%",
    borderLeft: "solid #3B86FF",
    // borderColor:'#56D9FE'
  },
  demo2: {
    position: "relative",

    paddingTop: "100px",
    padding: "20px",
    zIndex: 1,
  },
  stepperButtons: {
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    bottom: "3%",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} style={{ paddingTop: "40px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
let sectionId = "";
let crfFromId = "";
function a11yProps(index, item) {
  sectionId = item.id;
  crfFromId = item.id;
  //   setCrfSectionId(item.id)
  //   setCrfFormId(item.coaching_request_form_id)
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}
let first = true;
export default function CustomizedTabs() {
  const classes = useStyles();
  const history = useHistory();
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [CoachinRequest, setCrfSection] = useState([]);
  const [crfAnswers, setCrfAnswers] = useState([]);
  const dispatch = useDispatch();
  const sessionStorage = window.sessionStorage.getItem("slug");
  const [userData, setUserData] = useState();
  const [additionalSection, setAdditionalSectionId] = useState("");
  const [assignmentId, setAssignmentId] = useState("");
  const [crfId, setCrfId] = useState("");
  let { slug } = useParams();
  const [answerData, setAnswerData] = useState({});
  const [crfDescription, setCrfDescription] = useState("");
  const [orgLogo, setOrgLogo] = useState("");
  const [prgName, setPrgName] = useState("");
  let quesArr = [];
  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log("newValue", newValue);
    FetchCafAnswer();
    window.scroll({ top: 0 });
  };

  const onChangeItem = (selectedItemValue) => {
    setUserData({ ...userData, [selectedItemValue.id]: selectedItemValue.value });
     setAnswerData({ ...answerData, [selectedItemValue.id]: selectedItemValue.value  });
};

  const setInputState = (inputStateValue, inputId, childId,checkBoxFlag=false) => {
    console.log(`object`, answerData, inputStateValue, inputId);
    if (childId) {
      const childObj = { ...answerData[inputId], [childId]: inputStateValue };
      setAnswerData({
        ...answerData,
        [inputId]: Object.keys(childObj).filter((item, index) =>
          Boolean(childObj[item])
        ),
      });
      setUserData({
        ...userData,
        [inputId]: { ...answerData[inputId], [childId]: inputStateValue },
      });
    } else {
      const answerKeys = Object.keys(answerData);

      if (answerKeys.length > 0 && answerKeys.includes(inputId.toString())) {
        if (!answerData[inputId].includes(inputStateValue)) {
          setAnswerData((prev) => {
            return {...prev, [inputId]:checkBoxFlag?[...prev[inputId], inputStateValue]:inputStateValue };
          });
        } else {
          let copy = answerData[inputId].filter((el) => el !== inputStateValue);
          setAnswerData((prev) => {
            return {
              ...prev,
              [inputId]: copy,
            };
          });
        }
      } else {
        setAnswerData({ ...answerData, [inputId]:checkBoxFlag? [inputStateValue]:inputStateValue });
      }
      setUserData({ ...userData, [inputId]: inputStateValue });
    }
  };
  const setQuestionChangeState = (selectedItemValue, inputId) => {
    setUserData({ ...userData, [selectedItemValue]: selectedItemValue });
    setAnswerData({ ...answerData, [inputId]: selectedItemValue });
    inputId == "Business Experience" &&
      setUserData({ ...userData, ref4: selectedItemValue.value });
  };

  const hidden = useHideOnScrolled();
console.log('additionalSection :>> ', additionalSection);
  const CafFetch = () => {
    DataService.getDirectData(`/coaching_agreement_forms/${slug}`)
      .then((res) => {
        // if(res.success){
        // console.log(`res.id`, res.id)
        setCrfId(res.coaching_agreement_form.id);
        let CoachinRequests =
          res.coaching_agreement_form.coaching_agreement_form_sections;
          let prgName = res.coaching_agreement_form.programme_name;
        setCrfSection(CoachinRequests);
        let description = res.coaching_agreement_form.description;
        setCrfDescription(description);
        let orgLogo = res.coaching_agreement_form.org_logo;
        setOrgLogo(orgLogo);
        setPrgName(prgName);
        setAssignmentId(res.coaching_agreement_form.assignment_id);
        localStorage.clear();
      })
      //     .catch((err) => {
      // // "You are not allowed to fill this form."
      // if(err.errors !== undefined && err.errors.toString() === "You are not allowed to fill this form."){
      // history.push({ pathname: `/otheruserlogin`, });
      // }
      //      });
      .catch((err) => {
        console.log("object :>> err ", err);
        history.push({ pathname: `/otheruserlogin` });
        localStorage.clear();
      });
  };

  const FetchCafAnswer = () => {
    const statusData = {
      assignment_id: assignmentId || null,
      id: slug,
    };

    DataService.getDirectData(`/coaching_agreement_form_answers/view_caf`, statusData).then(
      (res) => {
        // if(res.success){
        let crfAnswer = res;
        let CoachinRequests = res.coaching_agreement_form.coaching_agreement_form_sections;
        setCrfSection(CoachinRequests);
        setCrfAnswers(crfAnswer);
        setLoading(false);
      }
    );
  };
  console.log('answerData :>> ', answerData);
  const handleSubmit = () => {
    console.log('answerData1 :>> ', answerData);
    for (var i in answerData) {
      quesArr.push({ coaching_agreement_form_field_id: i, value: answerData[i],additional_section_id: additionalSection[i] })
    }
    const statusData = {
      coaching_agreement_form_section_id: crfFromId,
      // additional_section_id: additionalSection,
      assignment_id: assignmentId,
      caf_answers: JSON.stringify(quesArr),
    };
    DataService.createData(statusData, "coaching_agreement_form_answers")
      .then((res) => {
        // const nameOfCoach =
        // empValue.id !== undefined
        //   ? empValue.full_name.toString()
        //   : empValue.full_name;
        // console.log("res", res.coaching_agreement_form.coaching_agreement_form_sections.filter(e => e.section_name === "Section A: Stakeholders")[0].coaching_agreement_form_fields.filter(e => e.field_value === "Name of Coach")[0].answer)
        // const nameOfCoach = res.coaching_agreement_form.coaching_agreement_form_sections.filter(e => e.section_name === "Section A: Stakeholders")[0].coaching_agreement_form_fields.filter(e => e.field_value === "Name of Coach")[0].answer
        // CafFetch()
        if (res.coaching_agreement_form) {
          if (value + 1 < CoachinRequest.length) {
            setValue(value + 1);
            dispatch(showSnackbar("success", ["Success!"]));
          }
          // dispatch(showSnackbar("success", ["Success!"]));
          // FetchCafAnswer()
          if (value + 1 === CoachinRequest.length) {
            history.push({ pathname: `/cafacknowledgement` });
          }
        } else {
          dispatch(showSnackbar("Error", [res?.message]));
        }
        setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]]));
      });
  };
  useEffect(() => {
    // setLoading(true);
    CafFetch();
    // Programmes()
    FetchCafAnswer();
    return () => {
      first = true;
    };
  }, []);

  return (
    <div>
      {/* <img
        src={BannerImage}
        className={classes.bannerStyle}
        alt={BannerImage}
        width="100%"
      /> */}

      <div class="parent">
        <img src={BannerImage} class="image1" alt={BannerImage} width="100%" />
        <img
          class="image2"
          src={orgLogo.length !== 0 && orgLogo.document.url}
          alt="logo"
        />
         <span class="image4">Program Name - {prgName}</span>
      </div>
      <div className={classes.root}>
        <Paper elevation={3} style={{ marginLeft: "11%", width: "80.6%" }}>
          <div className={classes.demo1}>
            <div class="" style={{ padding: "20px" }}>
              {crfDescription}
            </div>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              {CoachinRequest.length > 0 &&
                CoachinRequest.map((item, index) => {
                  return (
                    <Tab
                      style={{ textTransform: "initial", height: "25px" }}
                      label={item.section_name}
                      {...a11yProps(index, item)}
                    />
                  );
                })}
            </Tabs>{" "}
          </div>

          {CoachinRequest.length > 0 &&
            CoachinRequest.map((item, index) => {
              return (
                <TabPanel className={classes.demo2} value={value} index={index}>
                  {/* <Paper style={{ padding: '25px' }} elevation={1} > */}
                  {/* CoachinRates[index].coaching_agreement_form_fields.length > 0 && CoachinRates[index].coaching_agreement_form_fields.map((row,i)=>( */}

                  {CoachinRequest[index].coaching_agreement_form_fields.length >
                    0 &&
                    CoachinRequest[index].coaching_agreement_form_fields.map(
                      (row) => (
                        <Grid
                          container
                          direction="row"
                          alignItems="flex-start"
                          style={{ marginBottom: 20 }}
                        >
                          <Grid
                            item
                            xs={
                              row.field_name === "Description"
                                ? 10
                                : row.field_type === "text_area" ||
                                  row.field_type === "Text area"
                                ? 12
                                : 5
                            }
                          >
                            <InputLabel
                              className={classes.labelText}
                              style={{
                                marginTop: "20px",
                                fontSize: "18px",
                                color: "black",
                              }}
                            >
                              {row.field_value}
                            </InputLabel>
                          </Grid>
                          <Grid
                            item
                            style={{
                              paddingTop:
                                row.field_type === "text_area" ||
                                row.field_type === "Text area"
                                  ? "20px"
                                  : "",
                            }}
                            xs={
                              row.field_type === "text_area" ||
                              row.field_type === "Text area"
                                ? 9
                                : 4
                            }
                          >
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              style={{ marginBottom: 20 }}
                            >
                              <Grid item xs={12}>
                                {(row.field_type === "text" ||
                                  row.field_type === "Text") && (
                                  <CustomInput
                                    defaultValue={row.answer}
                                    id={row.id}
                                    variant="outlined"
                                    placeholder="Answer"
                                    parentcall={setInputState}
                                  />
                                )}
                                {(row.field_type === "text_area" ||
                                  row.field_type === "Text area") && (
                                  <CustomInput
                                    multiline
                                    rows="4"
                                    id={row.id}
                                    defaultValue={row.answer}
                                    variant="outlined"
                                    parentcall={setInputState}
                                  />
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={0}></Grid>
                          <Grid item xs={2}></Grid>
                        </Grid>
                      )
                    )}
                  {CoachinRequest[index].sub_heading.map(
                    (tempArr, addIndex) => (
                      <React.Fragment>
                        <Grid
                          container
                          direction="row"
                          alignItems="flex-start"
                          style={{ marginBottom: 20, marginTop: 20 }}
                        >
                          <Grid item xs={10}>
                            <InputLabel
                              className={classes.labelText}
                              style={{
                                fontWeight: "bold",
                                padding: "12px",
                                backgroundColor: "#F2F2F2",
                              }}
                            >
                              <Typography variant="h2">
                                {tempArr.sub_heading}
                              </Typography>
                            </InputLabel>
                          </Grid>
                          {/* <Grid item xs={2}>
                                  <IconButton
                                    onClick={() => {
                                      setAction("edit");
                                      setCrfSectionId(tempArr.coaching_request_form_id)
                                      setCurrentSelection(tempArr)
                                    }}
                                    edge="start"
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: 25,
                                        marginTop: "-3px",
                                      }}
                                    />
                                  </IconButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                </Grid> */}
                        </Grid>
                        {tempArr.coaching_agreement_form_fields.map(
                          (row, i) => (
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              style={{ marginBottom: 20, marginTop: 20 }}
                            >
                               <Grid
                                        item
                                        xs={
                                          (row.field_type === "Description" || row.field_type === "description")
                                            ? 9
                                            : row.field_type === "Text area" ||
                                              row.field_type === "Description"
                                            ? 12
                                            : 5
                                        }
                                      >

                                <InputLabel
                                  className={classes.labelText}
                                  style={{ padding: "12px" }}
                                >
                                  <Typography variant="h2">
                                    {row.field_value}
                                  </Typography>
                                </InputLabel>
                              </Grid>
                              {(row.field_type !== "Description" || row.field_type !== "description") && (  <Grid
                                item
                                style={{
                                  paddingTop:
                                    row.field_type === "Text area"
                                      ? "20px"
                                      : "",
                                }}
                                xs={
                                  row.field_value === "description"
                                    ? 0
                                    : row.field_type === "Text area"
                                    ? 9
                                    : 4
                                }
                              >
                                <Grid
                                  container
                                  direction="row"
                                  alignItems="center"
                                  style={{ marginBottom: 20 }}
                                >
                                  <Grid item xs={12}>
                                    {(row.field_type === "text" ||
                                      row.field_type === "Text") &&
                                      ( row.field_type !==
                                        "Description" ||
                                      row.field_type !==
                                        "description") && (
                                        <CustomInput
                                          multiline
                                          rows="4"
                                          id={row.id}
                                          defaultValue={row.answer}
                                          variant="outlined"
                                          parentcall={setInputState}
                                          AdditionalSection={(e) =>
                                            setAdditionalSectionId(
                                              row.additional_section_id
                                            )
                                          }
                                        />
                                      )}
                                    {(row.field_type === "text_area" ||
                                      row.field_type === "Text area" ) &&
                                      ( row.field_type !==
                                        "Description" ||
                                      row.field_type !==
                                        "description") && (
                                      <CustomInput
                                        multiline
                                        rows="4"
                                        id={row.id}
                                        defaultValue={row.answer}
                                        variant="outlined"
                                        parentcall={setInputState}
                                        AdditionalSection={(e) =>
                                          setAdditionalSectionId(
                                            row.additional_section_id
                                          )
                                        }
                                      />
                                    )}
                                    {(row.field_type === "dropdown" ||
                                      row.field_type === "Dropdown" ||
                                      row.field_type === "Drop down") && (
                                      // <Select
                                      //   helperText="Please select Location"
                                      //   variant="outlined"
                                        
                                      //   style={{ width: "100%" }}
                                      //   inputProps={{
                                      //     id: "outlined-age-native-simple",
                                      //   }}
                                      // ></Select>
                                          <CustomSelect
                                          id={row.id}
                            labelText="Select a value"
                            defaultValue={row.answer}
                            displayEmpty
                            variant="outlined"
                            itemArr={row.option}
                            parentcall={onChangeItem}
                          
                          />
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>)}
                              {row.organisation_metrics &&
                                row.organisation_metrics !== undefined &&
                                row.organisation_metrics.map((rowCheck) => {
                                  return (
                                    <Grid item xs={6}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            name={rowCheck.field_value}
                                            color="primary"
                                            onChange={(e) =>
                                              setInputState(
                                               
                                                row.id,
                                                rowCheck.id
                                              )
                                            }

                                            //   checked={Boolean(checkBoxValue[data?.name])}
                                          />
                                        }
                                        //   onChange={handleCheckboxValue}
                                        label={
                                          <Typography variant="h2">
                                            {row.field_value}
                                          </Typography>
                                        }
                                        //   className={classes.paper}
                                      />
                                    </Grid>
                                  );
                                })}
                              {row.compteencies &&
                                row.compteencies.map((item, index) => (
                                  <ListItem key={index}>
                                    <Checkbox
                                      // checked={state[item.value]}
                                      // onChange={handleChangeWO}
                                      name={item.name}
                                    />
                                    <Typography variant="h2">
                                      {item.name}
                                    </Typography>
                                  </ListItem>
                                ))}
                            </Grid>
                          )
                        )}

                        {tempArr.objectives.map((row1, i) => (
                          <React.Fragment>
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              style={{
                                marginBottom: 20,
                                marginTop: 20,
                                backgroundColor: "#F2F2F2",
                              }}
                            >
                              <Grid item xs={10}>
                                <InputLabel>
                                  <Typography
                                    variant="subtitle1"
                                    style={{
                                      fontWeight: "bold",
                                      padding: "12px",
                                      color: "#4D4F5C",
                                    }}
                                  >
                                    {row1.objective_name}
                                  </Typography>
                                </InputLabel>
                              </Grid>
                            </Grid>
                            {row1.coaching_agreement_form_fields &&
                              row1.coaching_agreement_form_fields !==
                                undefined &&
                              row1.coaching_agreement_form_fields.map(
                                (row, i) => (
                                  <Grid
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginBottom: 20, marginTop: 20 }}
                                  >
                                    <Grid
                                      item
                                      xs={
                                        row.field_value === "description"
                                          ? 10
                                          : row.field_type === "Text area" ||
                                            row.field_type === "Heading"
                                          ? 12
                                          : 5
                                      }
                                    >
                                      {row.field_type === "Heading" ? (
                                        <InputLabel style={{ padding: "12px" }}>
                                          <Typography
                                            variant="h1"
                                            style={{ fontWeight: "bold" }}
                                          >
                                            {row.field_value}
                                          </Typography>
                                        </InputLabel>
                                      ) : (
                                        <InputLabel
                                          className={classes.labelText}
                                          style={{ padding: "12px" }}
                                        >
                                          <Typography variant="h2">
                                            {row.field_value}
                                          </Typography>
                                        </InputLabel>
                                      )}
                                    </Grid>
                                    <Grid
                                      item
                                      style={{
                                        paddingTop:
                                          row.field_type === "Text area"
                                            ? "20px"
                                            : "",
                                      }}
                                      xs={
                                        row.field_value === "description"
                                          ? 0
                                          : row.field_type === "Text area"
                                          ? 9
                                          : 4
                                      }
                                    >
                                      <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        style={{ marginBottom: 20 }}
                                      >
                                        <Grid item xs={12}>
                                          {(row.field_type === "text" ||
                                            row.field_type === "Text") &&
                                            row.field_value !==
                                              "description" && (
                                              <CustomInput
                                                multiline
                                                rows="4"
                                                id={row.id}
                                                defaultValue={row.answer}
                                                variant="outlined"
                                                parentcall={setInputState}
                                              />
                                            )}
                                          {(row.field_type === "text_area" ||
                                            row.field_type === "Text area" ||
                                            row.field_type ===
                                              "Description") && (
                                            <CustomInput
                                              multiline
                                              rows="4"
                                              id={row.id}
                                              defaultValue={row.answer}
                                              variant="outlined"
                                              parentcall={setInputState}
                                            />
                                          )}
                                          {(row.field_type === "dropdown" ||
                                            row.field_type === "Dropdown" ||
                                            row.field_type === "Drop down") && (
                                            <Select
                                              helperText="Please select Location"
                                              variant="outlined"
                                              style={{ width: "100%" }}
                                              inputProps={{
                                                id: "outlined-age-native-simple",
                                              }}
                                            ></Select>
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    {row.organisation_metrics && row.organisation_metrics !== undefined && row.organisation_metrics.map((row2,ind) => {
                            if (first && ind === 0) {
                                              setAnswerData({
                                                [row.id]: [row.answer && row.answer.split(",")]
                                                  .flatMap((el) => el)
                                                  .reduce(
                                                    (acc, x) => acc.concat(+x),
                                                    []
                                                  ),
                                              });

                                              first = false;
                                            }
                            
                                    return (
                                      <Grid item xs={6}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              name={row2.field_value}
                                              color="primary"
                                              id={row2.id}
                                              // disabled
                                              onChange={(e) => setInputState( row2.id,row.id,false,true)}
                                              // checked={row?.answer}
                                              checked={answerData[
                                                        row.id
                                                      ]?.includes(row2.id)}
                                            />
                                          }
                                          //   onChange={handleCheckboxValue}
                                          label={<Typography variant="h2">{row2.name}</Typography>}
                                        //   className={classes.paper}
                                        />
                                        
{console.log('row?.answer} :>> ', row.answer, row2.id, row.answer === row2.id.toString(),userData,answerData)}

                                      </Grid>

                                    );
                                  })}
                                    {row.compteencies &&
                                      row.compteencies.map((item, index) => (
                                        <ListItem key={index}>
                                          <Checkbox
                                            // checked={state[item.value]}
                                            // onChange={handleChangeWO}
                                            name={item.name}
                                          />
                                          <Typography variant="h2">
                                            {item.name}
                                          </Typography>
                                        </ListItem>
                                      ))}
                                  </Grid>
                                )
                              )}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    )
                  )}
                  <Grid container direction="row" alignItems="flex-start">
                    <Grid item xs={10}></Grid>
                    <Grid item xs={2}>
                      <div className={classes.stepperButtons}>
                        <Button
                          disableElevation={loading}
                          variant="contained"
                          color="primary"
                          className={classes.btnSearch}
                          onClick={handleSubmit}
                        >
                          {loading && (
                            <CircularProgress
                              className={classes.circularProgress}
                              size={20}
                            />
                          )}
                          {value + 1 === CoachinRequest.length
                            ? "Submit"
                            : "Save"}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                
                 
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                >
                  <Grid item xs={10}></Grid>
                  <Grid item xs={2}>
                    <div className={classes.stepperButtons}>
                      <Button
                        disableElevation
                        ={loading}
                        variant="contained"
                        color="primary"
                        className={classes.btnSearch}
                        onClick={handleSubmit}
                      >
                        {loading && (
                          <CircularProgress
                            className={classes.circularProgress}
                            size={20}
                          />
                        )}
                        {value + 1 === CoachinRequest.length
                          ? "Submit"
                          : "Save"}
                      </Button>
                    </div>
                  </Grid>
               
                </Grid>
              {/* </Paper> */}
            </TabPanel>
          );
        })}
     </Paper> </div>
    </div>
  );
}
